import Vue from "vue";
import axios from "axios";
import "../../filters";
import moment from "moment";
import * as files from "../../fileUtils";
import { WebCam } from "vue-web-cam";
import { find, head, last } from "lodash";
import { latitude } from "devexpress-dashboard/model/index.metadata";
import createDateTimeForBackEnd from "@/employee/omApplications/common/omApplicationTools";

Vue.component(WebCam.name, WebCam);

export default {
  name: "Jobcard",
  mixins: [createDateTimeForBackEnd],
  components: {
    JobcardDetailComp: require("./jobcard/jobcardDetail.vue").default,
    StepsComp: require("./jobcard/steps.vue").default,
    ManpowersComp: require("./common/manpowers.vue").default,
    SupportsComp: require("./common/supports.vue").default,
    StoresComp: require("./jobcard/stores.vue").default,
    CustomFieldsComp: require("../../components/customFields.vue").default,
    AttachmentsComp: require("../../components/attachments.vue").default,
    WebCam,
  },
  props: ["dataObj"],
  data: function () {
    return {
      cameraStarted: false,

      coordinates: {},
      window: {
        width: 0,
        height: 0,
        isMobile: false,
      },
      omApp: {
        type: 0,
        status: 0,
        stage: 0,
        sourceId: -1,
        investigationId: -1,
        jobcardId: -1,
        address: "",
        workflowEmployeeId: -1,
        applicationDate: new Date(),
      },
      jobcardData: {
        id: -1,
        originType: "-1",
        originId: -1,
        stationId: -1,
        startDateTime: new Date(),
        endDateTime: new Date(),
        actualDuration: 0,
        actualTravelDuration: 0,
        address: "",
        mActivityId: -1,
        elementTypeId: -1,
        elementId: -1,
        conditionId: -1,
        conditionComment: "",
        complainTypeId: -1,
        outcomeId: -1,
        comment: "",
        workflowEmployeeId: -1,
        dataChildren: undefined,
      },
      activeTab: "tab-detail",
      jobcardId: -1,
      workflowEmployees: [],
      stations: [],
      customFields: { items: [] },
      employeeUsage: 1,
      dataChildren: {
        sourceId: this.jobcardId,
        empUsage: this.employeeUsage,
        workDuration: 0,
        travelDuration: 0,
      },
      attachments: {
        files: [],
        permissions: { add: true, delete: true, download: true },
        sort: true,
        download: this.download,
        mimeTypes:
          "image/png,image/jpeg,application/pdf,application/msword,application/excel",
        multiple: false,
        maxFilesNumber: 3,
        cntrlItemsHelp: [],
      },
      bDisableButton: false,
      showImage: false,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      message: "",
    };
  },
  computed: {
    actualDuration: function () {
      return this.jobcardData.actualDuration;
    },
    actualTravelDuration: function () {
      return this.jobcardData.actualTravelDuration;
    },
    device: function () {
      return find(this.devices, (n) => n.deviceId == this.deviceId);
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      //let firsty = head(this.devices);
      let firsty = last(this.devices);
      if (firsty) {
        this.camera = firsty.deviceId;
        this.deviceId = firsty.deviceId;
      }
    },
  },
  created() {
    this.init();
    this.$root.$on("omApplication_updated", this.init);
    this.$root.$on("problemLog_updated", this.setAddress);
    this.employeeUsage = 1;
    //start
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    //end
  },
  //start
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }, //end
  methods: {
    isActive(item) {
      return this.activeTab == item ? "md-primary md-raised" : "";
    },
    setActiveTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (window.innerWidth <= 890) {
        this.window.isMobile = true;
      } else {
        this.window.isMobile = false;
      }
    },
    init() {
      Vue.nextTick(() => {
        if (this.dataObj.jobcardId <= 0) return;
        this.omApp = this.dataObj;
        this.jobcardId = this.dataObj.jobcardId;
        this.getJobcard(this.jobcardId);
        this.getAttachments(this.jobcardId);
        this.getJobcardCustomFields();
      });
    },
    setAddress() {
      if (this.dataObj.address && this.dataObj.address.length > 0)
        this.jobcardData.address = this.dataObj.address;
    },
    getJobcardCustomFields() {
      axios
        .post("/Om/GetJobcardCustomFields", { Value: this.jobcardId })
        .then((response) => {
          if (response.data.data.status == 0) {
            response.data.items.forEach((i) => {
              if (i.dateValue == "1899-12-30T00:00:00")
                i.dateValue = moment().format();

              if (i.dateTimeValue == "1899-12-30T00:00:00")
                i.dateTimeValue = moment().format();
            });
            this.customFields.items = response.data.items;

            this.$root.$emit("custom_fields_updated");
          } else {
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch((e) => {
          console.log("getJobcardCustomFields");
          console.log(e);
          this.$router.push("/login");
          return false;
        });
    },
    getJobcard(id) {
      axios
        .post("/Om/GetJobcard", { Value: id })
        .then((response) => {
          if (response.data.data.status == 0) {
            if (this.jobcardData.address && this.jobcardData.address.length > 0)
              response.data.item.address = this.jobcardData.address;
            this.jobcardData = response.data.item;
            this.dataChildren.sourceId = this.jobcardId;
            this.dataChildren.stationId = this.jobcardData.stationId;
            this.dataChildren.empUsage = this.employeeUsage;
            this.dataChildren.workDuration = this.jobcardData.actualDuration;
            this.dataChildren.travelDuration =
              this.jobcardData.actualTravelDuration;

            this.jobcardData.jobCardStartDate = response.data.startDateTime;
            this.jobcardData.jobCardEndDate = response.data.endDateTime;

            this.jobcardData.dateFromHH = moment(
              this.jobcardData.startDateTime
            ).format("HH");
            this.jobcardData.dateFromMin = moment(
              this.jobcardData.startDateTime
            ).format("mm");
            this.jobcardData.dateToHH = moment(
              this.jobcardData.endDateTime
            ).format("HH");
            this.jobcardData.dateToMin = moment(
              this.jobcardData.endDateTime
            ).format("mm");
            this.jobcardData.startDateTime = moment(
              this.jobcardData.startDateTime
            ).format("DD/MM/YYYY");
            this.jobcardData.endDateTime = moment(
              this.jobcardData.endDateTime
            ).format("DD/MM/YYYY");
            this.jobcardData.dataChildren = this.dataChildren;

            this.$root.$emit("investigation_or_jobcard_updated");
          } else this.$oldAlertMsg(response.data.data.text, 4);
        })
        .catch((e) => {
          console.log("getJobcard");
          console.log(e);
          this.$router.push("/login");
        });
    },
    saveCustomFields(sMsg) {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      this.customFields.items.forEach((i) => {
        if (!i.dateValue) i.dateValue = "1899-12-30T00:00:00";

        if (!i.dateTimeValue) i.dateTimeValue = "1899-12-30T00:00:00";
      });
      var parameter = {
        ApplicationId: this.jobcardId,
        Values: this.customFields.items,
        Language: this.$i18n.locale,
      };
      axios
        .post("/Om/SaveJobcardCustomFieldValues", parameter)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.$oldAlertMsg(sMsg, 2);
          } else this.$oldAlertMsg(response.data.data.text, 4);

          loader.hide();
        })
        .catch((e) => {
          console.log("saveCustomFields");
          console.log(e);
          loader.hide();
          this.$router.push("/login");
        });
    },
    setJobcardElement(sMsg) {
      axios
        .post("/Om/SetJobcardElement", {
          ObjectId: this.jobcardId,
          MActivityId: this.jobcardData.mActivityId,
          ElementTypeId: this.jobcardData.elementTypeId,
          ElementId: this.jobcardData.elementId,
        })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.$oldAlertMsg(sMsg, 2);
          } else this.$oldAlertMsg(response.data.data.text, 4);
        })
        .catch((e) => {
          console.log("setJobcardElement");
          console.log(e);
          this.$oldAlertMsg(e.message, 4);
        });
    },
    async saveDetails() {
      if (
        !this.jobcardData.startDateTime ||
        !this.jobcardData.dateFromHH ||
        !this.jobcardData.dateFromMin ||
        !this.jobcardData.endDateTime ||
        !this.jobcardData.dateToHH ||
        !this.jobcardData.dateToMin
      ) {
        this.$oldAlertMsg("Please Complete all Dates/Times", 4);
        return;
      }

      let param = {
        Id: this.jobcardId,
        StartDateTime: this.createDateTimeForBackEnd(
          this.jobcardData.startDateTime,
          this.jobcardData.dateFromHH,
          this.jobcardData.dateFromMin
        ),
        EndDateTime: this.createDateTimeForBackEnd(
          this.jobcardData.endDateTime,
          this.jobcardData.dateToHH,
          this.jobcardData.dateToMin
        ),
        DateFromHH: this.jobcardData.dateFromHH,
        DateFromMin: this.jobcardData.dateFromMin,
        DateToHH: this.jobcardData.dateToHH,
        DateToMin: this.jobcardData.dateToMin,
        ConditionComment: this.jobcardData.conditionComment,
        Comment: this.jobcardData.comment,
        TeamComment: this.jobcardData.teamComment,
      };

      if (this.jobcardData.actualDuration)
        param["ActualDuration"] = parseInt(this.jobcardData.actualDuration);

      if (this.jobcardData.actualTravelDuration)
        param["ActualTravelDuration"] = parseInt(
          this.jobcardData.actualTravelDuration
        );

      if (this.jobcardData.complainTypeId)
        param["ComplainTypeId"] = parseInt(this.jobcardData.complainTypeId);

      if (this.jobcardData.conditionId)
        param["ConditionId"] = parseInt(this.jobcardData.conditionId);

      if (this.jobcardData.outcomeId)
        param["OutcomeId"] = parseInt(this.jobcardData.outcomeId);

      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      await navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.coordinates = pos;
        },
        (err) => {
          this.$oldAlertMsg(err.message, 4);
        },
        geoOptions
      );

      if (this.coordinates != null && this.coordinates.coords != null) {
        param["MarkedPositionY"] = this.coordinates.coords.latitude;
        param["MarkedPositionX"] = this.coordinates.coords.longitude;
      }

      var loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/Om/UpdateJobcardDetails", param)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.$oldAlertMsg(this.$t("messages.JobcardSavedSuccess"), 2);
            this.saveCustomFields(this.$t("messages.CustomFieldSavedSuccess"));
            this.setJobcardElement(
              this.$t("messages.JobcardElementSetSuccess")
            );
          } else this.$oldAlertMsg(response.data.data.text, 4);

          loader.hide();
        })
        .catch((e) => {
          console.log("saveDetails");
          console.log(e);
          loader.hide();
          this.$oldAlertMsg(e.message, 4);
        });
    },
    completeJobcard() {
      if (this.jobcardData.outcomeId <= 0) {
        this.$oldAlertMsg(this.$t("messages.pleaseSelectOutcome"), 4);
        return;
      }

      var param = {
        Id: this.jobcardId,
        StartDateTime: this.jobcardData.startDateTime,
        EndDateTime: this.jobcardData.endDateTime,
        ActualDuration: this.jobcardData.actualDuration,
        ActualTravelDuration: this.jobcardData.actualTravelDuration,
        ConditionId: this.jobcardData.conditionId,
        ConditionComment: this.jobcardData.conditionComment,
        ComplainTypeId: this.jobcardData.complainTypeId,
        OutcomeId: this.jobcardData.outcomeId,
        Comment: this.jobcardData.comment,
        DateFromHH: this.jobcardData.dateFromHH,
        DateFromMin: this.jobcardData.dateFromMin,
        DateToHH: this.jobcardData.dateToHH,
        DateToMin: this.jobcardData.dateToMin,
        TeamComment: this.jobcardData.teamComment,
      };

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/Om/UpdateJobcardDetails", param)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.saveCustomFields();

            axios
              .post("/Om/SetJobcardElement", {
                ObjectId: this.jobcardId,
                MActivityId: this.jobcardData.mActivityId,
                ElementTypeId: this.jobcardData.elementTypeId,
                ElementId: this.jobcardData.elementId,
              })
              .then((response) => {
                if (response.data.data.status == 0) {
                  this.$oldAlertMsg(
                    this.$t("messages.JobcardElementSetSuccess"),
                    2
                  );

                  axios
                    .post("/Om/CompleteJobcard", {
                      Id: this.jobcardId,
                      OutcomeId: this.jobcardData.outcomeId,
                      Comment: this.jobcardData.comment,
                    })
                    .then((response) => {
                      if (response.data.data.status == 0) {
                        this.getJobcard(this.jobcardId);
                        this.$oldAlertMsg(
                          this.$t("messages.JobcardCompletedSuccess"),
                          2
                        );
                      } else this.$oldAlertMsg(response.data.data.text, 4);

                      loader.hide();
                    })
                    .catch((e) => {
                      loader.hide();
                      this.$oldAlertMsg(e.message, 4);
                    });
                } else this.$oldAlertMsg(response.data.data.text, 4);

                loader.hide();
              })
              .catch((e) => {
                console.log("completeJobcard=>SetJobcardElement");
                console.log(e);
                loader.hide();
                this.$oldAlertMsg(e.message, 4);
              });
          } else this.$oldAlertMsg(response.data.data.text, 4);
        })
        .catch((e) => {
          console.log("completeJobcard");
          console.log(e);
          loader.hide();
          this.$oldAlertMsg(e.message, 4);
        });
    },
    getAttachments(jobcardId) {
      this.bDisableButton = true;
      axios
        .get("/OmActivityBase/GetAttachments?source=1&objectId=" + jobcardId)
        .then((response) => {
          //console.log("get attach", response);
          if (response.status == 200) {
            var files = response.data;
            this.attachments.files = [];
            for (var i = 0; i < files.length; ++i) {
              var file = files[i];
              this.attachments.files.push({
                id: file.id,
                seqId: 0,
                deleted: false,
                name: file.fileName,
              });
            }
          } else
            this.closeWithMessage(
              this.$t("messages.CannotGetAttachmentsFromServer"),
              1
            );
          this.bDisableButton = false;
        })
        .catch((e) => {
          console.log("getAttachments");
          console.log(e);
          this.bDisableButton = false;
          //this.$router.push('/login');
        });
    },
    processPhotos() {
      if (!this.img || this.img.length < 25) return;

      var formData = new FormData();
      formData.append("objectId", this.jobcardId.toString());
      formData.append("photoBase64", this.img);
      formData.append("source", "1");

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });

      return axios
        .post("/OmActivityBase/ProcessPhoto", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.$root.$emit("camera_photos_updated");
          this.getAttachments(this.jobcardId);
          loader.hide();
        })
        .catch((e) => {
          loader.hide();
          console.log("processPhotos");
          console.log(e);
          //this.$router.push('/login');
          return false;
        });
    },
    processAttachments(uploadFiles, deleteFiles) {
      var fileNameList = [];
      var formData = new FormData();
      formData.append("objectId", this.jobcardId.toString());
      formData.append("source", "1");

      console.log("ddd", this.deleteFiles);
      for (var i = 0; i < uploadFiles.length; ++i) {
        formData.append("uploadFiles", uploadFiles[i]);
        fileNameList.push(uploadFiles[i].name);
      }

      for (var i = 0; i < deleteFiles.length; ++i)
        formData.append("deleteFiles", deleteFiles[i]);

      this.bDisableButton = true;
      this.loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/OmActivityBase/ProcessAttachments", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status == 200) {
            this.$oldAlertMsg(this.$t("messages.AttachmentSavedSuccess"), 2);
            this.getAttachments(this.jobcardId);
          } else this.$oldAlertMsg(response.data.data.text, 4);
          this.bDisableButton = false;
          this.loader.hide();
        })
        .catch((e) => {
          console.log("processAttachments");
          console.log(e);
          this.bDisableButton = false;
          this.loader.hide();
          return false;
        });
    },
    saveAttachments() {
      if (this.bDisableButton === true) return;

      var newFiles = [];
      var deleteFiles = [];

      this.attachments.files.forEach(function (file) {
        if (file.id < 0)
          // new
          newFiles.push(file.file);
        else if (file.deleted) deleteFiles.push(file.id);
      });

      if (deleteFiles.length > 0 || newFiles.length > 0)
        this.processAttachments(newFiles, deleteFiles);
    },
    savePhoto() {
      this.processPhotos();
      this.showImage = false;
    },
    discardPhoto() {
      this.img = null;
      this.showImage = false;
    },
    onCapture() {
      console.log("this.$refs", this.$refs);
      this.img = this.$refs.webcam.capture();
      this.$forceUpdate();
      this.showImage = true;
    },
    onStarted(stream) {
      this.cameraStarted = true;
      //console.log('On Started Event', stream);
    },
    onStopped(stream) {
      this.cameraStarted = false;
      //console.log('On Stopped Event', stream);
    },
    onStop() {
      this.$refs.webcam.stop();
      this.cameraStarted = false;
    },
    onStart() {
      this.$refs.webcam.start();
      this.cameraStarted = true;
    },
    onError(error, stream) {
      console.log("On Error Event", error, stream);
    },
    onCameras(cameras) {
      this.devices = cameras;
      //console.log('On Cameras Event', cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      //console.log('On Camera Change Event', deviceId);
    },
    close() {
      this.$router.replace("/omApplications");
    },
    closeWithMessage(msg, type, timeout = 3000) {
      this.message = msg;
      if (type == 1)
        this.message += " If the problem repeats please contact Support";
      this.$oldAlertMsg(msg, 4);
      setTimeout(
        function () {
          this.close();
        }.bind(this),
        timeout
      );
    },
    download(id) {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post(
          "/OmActivityBase/DownloadAttachment",
          { Value: id },
          { responseType: "blob" }
        )
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .then((response) => {
          loader.hide();
        })
        .catch((err) => {
          console.log("download");
          console.log(err);
          loader.hide();
        });
    },
  },
};
